import { Drawer } from 'antd';
import './DrawerDetailModule.scss';
import { Icon } from '../../../../components/icon/icon';
import { Divider } from 'antd';
import { useEffect, useState } from 'react';
import ButtonIconOutlineMedium from '../../../../components/common/ButtonIconOutline/ButtonIconOutlineMedium';
import { useSelector } from 'react-redux';
import { mapListObjectByKey } from '../../../../utils/data/map.utils';
import { roundTo } from '../../../../utils/geometry/epsilon';
import { useTranslation } from 'react-i18next';
import CardItem from '../../../../components/card/CardItem/CardItem';
import { InsideType } from '../../../../constants/enum';
import {
  convertCodeToName,
  convertTypeToName,
} from '../../../../utils/string/string.utils';
import { capitalize } from 'lodash';
import { getValueFromString } from '../../../../utils/data/getValue.utils';
import { parseJson } from '../../../../utils/string/parseJson';
import ButtonSecondaryMedium from '../../../../components/common/ButtonSecondary/ButtonSecondaryMedium';
import PreviewImage from '../../../../components/common/PreviewImage/PreviewImage';
import TabComponent from '../../../../components/common/TabComponent/TabComponent';
import { convertForeignCurrency } from '../../../../utils/currency/currency.utils';

const DrawerDetailModule = ({ items, imageList, prices, open, onClose }) => {
  // const { cart } = useSelector(state => state.room);
  const [data, setData] = useState();
  const [accessories, setAccessories] = useState([]);
  const [countertop, setCountertop] = useState();
  const [backsplash, setBacksplash] = useState();
  const [showPreview, setShowPreview] = useState(false);
  const [tab, setTab] = useState('wood');

  const { t } = useTranslation();

  const renderCardItem = item => {
    const textureFrame = item?.textures?.frame;
    const content = [];
    if (item.size) {
      content.push(
        <span className="line-clamp-1 truncate text-body-medium">
          {`${item.size}`}
        </span>
      );
    }
    if (textureFrame) {
      if (textureFrame.material) {
        content.push(
          <span className="text-body-medium">{`${textureFrame.material}`}</span>
        );
      }
      if (textureFrame.textureCode || textureFrame.paintColor) {
        content.push(
          <span className="flex items-start justify-start gap-[4px] flex-wrap">
            <span className="text-body-medium ellipsis-multiline-1">
              {textureFrame.supplier?.name}
            </span>
            •
            <span className="text-body-medium ellipsis-multiline-1">
              {(() => {
                if (textureFrame.supplier?.materialType === 'M') {
                  return t('Melamine-coated MDF');
                } else if (textureFrame.supplier?.materialType === 'L') {
                  return t('Moisture-resistant MDF');
                } else return textureFrame.supplier?.materialType;
              })()}
            </span>
            •
            <div className="flex items-center gap-8 self-stretch">
              <span className="text-body-medium ellipsis-multiline-1">
                {textureFrame.paintColor ?? textureFrame.textureCode}
              </span>
              <div className="flex w-[24px] h-[14px] rounded-[2px] border-[0.5px] overflow-hidden">
                {textureFrame.paintColor ? (
                  <span className={`bg-[${textureFrame.paintColor}]`} />
                ) : (
                  <img src={textureFrame.textureUrl} alt="texture" />
                )}
              </div>
            </div>
          </span>
        );
      }
    }
    if (item.price) {
      content.push(
        <span className="line-clamp-1 truncate text-body-medium-emphasized text-black-medium">
          {convertForeignCurrency(item.price)}
        </span>
      );
    }
    return (
      <>
        <CardItem
          icon={item.thumbnail_url}
          title={
            item.name
              ? getValueFromString(item.name)
              : convertTypeToName(item.type)
          }
          content={
            <div className="flex items-start justify-start flex-col gap-[4px] self-stretch">
              {content}
            </div>
          }
        />
      </>
    );
  };

  const renderSubCardItem = item => {
    const textureFrame = item?.textures?.frame;
    const textureDoor = item?.textures?.DOOR;
    const textureGlass = item?.textures?.['GLASS-PANEL'];
    const insides = item.listInside
      ?.filter(item =>
        [
          InsideType.DOOR,
          InsideType.HPANEL,
          InsideType.VPANEL,
          InsideType.DRAWER,
          InsideType.U_DRAWER,
          InsideType.VCURVE,
          InsideType.HANDLE,
          InsideType.VPANEL2,
          InsideType.CLOTHES_HANGER,
          InsideType.HPANEL_RIGHT,
          InsideType.HPANEL_LEFT,
        ].includes(item.type)
      )
      .reduce((prev, curr) => {
        const index = prev.findIndex(i => i.name === curr.name);
        if (index >= 0) {
          const arr = [...prev];
          arr[index] = {
            ...arr[index],
            quantity: arr[index].quantity + 1,
          };
          return arr;
        }
        return [...prev, { ...curr, quantity: 1 }];
      }, [])
      .toSorted((a, b) => {
        if (
          [InsideType.DOOR].includes(a.type) &&
          ![InsideType.DOOR].includes(b.type)
        )
          return -1;
        if (
          ![InsideType.DOOR].includes(a.type) &&
          [InsideType.DOOR].includes(b.type)
        )
          return 1;
        if (
          ![
            InsideType.HPANEL,
            InsideType.VPANEL,
            InsideType.DRAWER,
            InsideType.U_DRAWER,
            InsideType.VCURVE,
            InsideType.VPANEL2,
            InsideType.HPANEL_RIGHT,
            InsideType.HPANEL_LEFT,
          ].includes(a.type) &&
          [
            InsideType.HPANEL,
            InsideType.VPANEL,
            InsideType.DRAWER,
            InsideType.U_DRAWER,
            InsideType.VCURVE,
            InsideType.VPANEL2,
            InsideType.HPANEL_RIGHT,
            InsideType.HPANEL_LEFT,
          ].includes(b.type)
        )
          return 1;
        if (
          [
            InsideType.HPANEL,
            InsideType.VPANEL,
            InsideType.DRAWER,
            InsideType.U_DRAWER,
            InsideType.VCURVE,
            InsideType.VPANEL2,
            InsideType.HPANEL_RIGHT,
            InsideType.HPANEL_LEFT,
          ].includes(a.type) &&
          ![
            InsideType.HPANEL,
            InsideType.VPANEL,
            InsideType.DRAWER,
            InsideType.U_DRAWER,
            InsideType.VCURVE,
            InsideType.VPANEL2,
            InsideType.HPANEL_RIGHT,
            InsideType.HPANEL_LEFT,
          ].includes(b.type)
        )
          return -1;
        if (
          [InsideType.CLOTHES_HANGER, InsideType.HANDLE].includes(a.type) &&
          ![InsideType.CLOTHES_HANGER, InsideType.HANDLE].includes(b.type)
        )
          return 1;
        if (
          ![InsideType.CLOTHES_HANGER, InsideType.HANDLE].includes(a.type) &&
          [InsideType.CLOTHES_HANGER, InsideType.HANDLE].includes(b.type)
        )
          return -1;
        return (
          a.name.localeCompare(b.name, 'vi', { numeric: true }) ||
          a.quantity - b.quantity
        );
      });
    return (
      <>
        {insides?.map((item, index) => {
          let paintColor;
          let textureUrl;
          let textureCode;
          let material;
          let supplier;
          const content = [];
          const name = item.name
            ? getValueFromString(item.name)
            : convertTypeToName(item.type);
          let price;
          const size = item.savedSize;

          if (item.type === InsideType.DOOR) {
            paintColor = textureDoor?.paintColor;
            textureUrl = textureDoor?.textureUrl;
            textureCode = textureDoor?.textureCode;
            material = textureDoor?.material;
            supplier = textureDoor?.supplier;
          } else if (
            [
              InsideType.HPANEL,
              InsideType.VPANEL,
              InsideType.DRAWER,
              InsideType.U_DRAWER,
              InsideType.VCURVE,
              InsideType.VPANEL2,
              InsideType.HPANEL_RIGHT,
              InsideType.HPANEL_LEFT,
            ].includes(item.type)
          ) {
            paintColor = textureFrame?.paintColor;
            textureUrl = textureFrame?.textureUrl;
            textureCode = textureFrame?.textureCode;
            material = textureFrame?.material;
            supplier = textureFrame?.supplier;
          } else if (
            [InsideType.HANDLE, InsideType.CLOTHES_HANGER].includes(item.type)
          ) {
            price = item.price;
          }

          if (material) {
            content.push(
              <span className="line-clamp-1 truncate text-body-medium">
                {material}
              </span>
            );
          }
          if (size) {
            content.push(
              <span className="line-clamp-1 truncate text-body-medium">
                {`${roundTo(size.x * 1000, 0)} x ${roundTo(size.y * 1000, 0)} x ${roundTo(size.z * 1000, 0)} mm`}
              </span>
            );
          }
          if (textureUrl && textureCode) {
            content.push(
              <span className="flex items-start justify-start gap-[4px] flex-wrap">
                <span className="text-body-medium ellipsis-multiline-1">
                  {supplier?.name}
                </span>
                •
                <span className="text-body-medium ellipsis-multiline-1">
                  {(() => {
                    if (supplier?.materialType === 'M') {
                      return t('Melamine-coated MDF');
                    } else if (supplier?.materialType === 'L') {
                      return t('Moisture-resistant MDF');
                    } else return supplier?.materialType;
                  })()}
                </span>
                •
                <div className="flex items-center gap-8 self-stretch">
                  <span className="text-body-medium ellipsis-multiline-1">
                    {paintColor ?? textureCode}
                  </span>
                  <div className="flex w-[24px] h-[14px] rounded-[2px] border-[0.5px] overflow-hidden">
                    {paintColor ? (
                      <span className={`bg-[${paintColor}]`} />
                    ) : (
                      <img src={textureUrl} alt="texture" />
                    )}
                  </div>
                </div>
              </span>
            );
          }
          if (paintColor) {
            content.push(
              <span className="line-clamp-1 truncate text-body-medium">
                <div className="flex items-center gap-8 self-stretch">
                  <span className="text-body-medium ellipsis-multiline-1">
                    {paintColor}
                  </span>
                  <div className="flex w-[24px] h-[14px]">
                    <span className={`bg-[${paintColor}]`}></span>
                  </div>
                </div>
              </span>
            );
          }
          if (textureGlass) {
            content.push(
              <span className="line-clamp-1 truncate text-body-medium">
                <div className="flex items-center gap-8 self-stretch">
                  <span className="text-body-medium ellipsis-multiline-1">
                    {getValueFromString(textureGlass.textureCode)}
                  </span>
                  <div className="flex w-[24px] h-[14px]">
                    <img src={textureGlass.textureUrl} alt="texture" />
                  </div>
                </div>
              </span>
            );
          }
          if (price) {
            content.push(
              <span className="line-clamp-1 truncate text-body-medium-emphasized text-black-medium">
                {convertForeignCurrency(item.price)}
              </span>
            );
          }
          return (
            <CardItem
              classNames={{ root: 'ps-[40px]' }}
              key={index}
              icon={item.thumbnail_url}
              title={t(name)}
              quantity={item.quantity}
              content={
                <div className="flẽx items-start justify-start gap-[4px]">
                  {content}
                </div>
              }
            />
          );
        })}
      </>
    );
  };

  const renderWoodDetail = () => {
    return (
      <>
        <div className="flex content-between items-center self-stretch px-[16px] py-[8px] rounded-[2px] bg-primary-primaryFill">
          <div className="flex flex-col items-start gap-[2px] grow">
            <span className="text-title-small">{t('Wood product')}</span>
            <span className="text-body-small">
              {`${data?.data?.modules?.length ?? 1} ${t('Product')}`}
            </span>
          </div>
          <div className="flex items-center self-stretch gap-[4px]">
            <span className="text-body-large font-semibold">
              {convertForeignCurrency((prices || data)?.total_wood_price)}
            </span>
          </div>
        </div>
        {Object.entries(data?.modules ?? {}).map(([key, modules]) => {
          return (
            <div
              key={key}
              className="flex flex-col items-start self-stretch lg:p-[16px] gap-[8px]"
            >
              <span className="lg:text-title-small text-title-medium lg:!font-semibold !font-bold">
                {t(capitalize(convertCodeToName(key)))}
              </span>
              <div className="flex flex-col items-start self-stretch p-[8px] gap-[8px] rounded-[8px] border-[1px] border-[#E0E0E0] border-solid">
                {modules.map((item, i) => {
                  return (
                    <div
                      key={i}
                      className="flex flex-col items-start gap-[8px] self-stretch"
                    >
                      {renderCardItem(item)}
                      {renderSubCardItem(item)}
                      {modules.length - 1 !== i ? (
                        <Divider className="m-0 !p-0" type="horizontal" />
                      ) : null}
                    </div>
                  );
                })}
              </div>
            </div>
          );
        })}
        {backsplash ? (
          <div className="flex flex-col items-start self-stretch">
            <div className="flex content-between items-center self-stretch px-[16px] py-[8px] rounded-[2px] bg-[#EDFAFF]">
              <div className="flex flex-col items-start gap-[2px] grow">
                <span className="text-title-small">{t('Backsplash')}</span>
              </div>
              <div className="flex items-center self-stretch gap-[4px]">
                <span className="text-body-large font-semibold">
                  {convertForeignCurrency(
                    prices?.total_backsplash_price ||
                      roundTo(backsplash?.total, 0)
                  )}
                </span>
              </div>
            </div>
            <div className="flex flex-col items-start self-stretch p-[16px] gap-[8px]">
              <div className="flex flex-col items-start self-stretch p-[8px] gap-[8px] rounded-[8px] border-[1px] border-[#E0E0E0] border-solid">
                {backsplash ? (
                  <CardItem
                    icon={backsplash.thumbnail_url}
                    title={backsplash.name}
                    quantity={0}
                    content={[
                      <span className="line-clamp-1 truncate text-body-medium text-black-medium min-w-full">
                        {t(backsplash.materialType)}
                      </span>,
                      <span className="line-clamp-1 truncate text-body-medium-emphasized text-black-medium">
                        {convertForeignCurrency(backsplash.price?.price)}
                        /m
                      </span>,
                    ]}
                  />
                ) : (
                  <></>
                )}
              </div>
            </div>
          </div>
        ) : null}
        {countertop ? (
          <div className="flex flex-col items-start self-stretch">
            <div className="flex content-between items-center self-stretch px-[16px] py-[8px] rounded-[2px] bg-[#EDFAFF]">
              <div className="flex flex-col items-start gap-[2px] grow">
                <span className="text-title-small">{t('Countertop')}</span>
              </div>
              <div className="flex items-center self-stretch gap-[4px]">
                <span className="text-body-large font-semibold">
                  {convertForeignCurrency(
                    prices?.total_countertop_price ||
                      roundTo(countertop?.total, 0)
                  )}
                </span>
              </div>
            </div>
            <div className="flex flex-col items-start self-stretch p-[16px] gap-[8px]">
              <div className="flex flex-col items-start self-stretch p-[8px] gap-[8px] rounded-[8px] border-[1px] border-[#E0E0E0] border-solid">
                {countertop ? (
                  <CardItem
                    icon={countertop.thumbnail_url}
                    title={countertop.name}
                    quantity={0}
                    content={[
                      <span className="line-clamp-1 truncate text-body-medium text-black-medium min-w-full">
                        {t(countertop.materialType)}
                      </span>,
                      <span className="line-clamp-1 truncate text-body-medium-emphasized text-black-medium">
                        {convertForeignCurrency(countertop.price?.price)}
                        /m
                      </span>,
                    ]}
                  />
                ) : (
                  <></>
                )}
              </div>
            </div>
          </div>
        ) : null}
      </>
    );
  };

  const renderAccessoriesAndEquipmentsDetail = () => {
    return (
      <>
        {accessories.length ? (
          <>
            <div className="flex content-between items-center self-stretch px-[16px] py-[8px] rounded-[2px] bg-[#EDFAFF]">
              <div className="flex flex-col items-start gap-[2px] grow">
                <span className="text-title-small">
                  {t('Accessories and Equipments')}
                </span>
                <span className="text-body-small">
                  {`${accessories?.length} ${t('Product')}`}
                </span>
              </div>
              <div className="flex items-center self-stretch gap-[4px]">
                <span className="text-body-large font-semibold">
                  {convertForeignCurrency(
                    (prices || data)?.total_accessory_price
                  )}
                </span>
              </div>
            </div>

            <div className="flex flex-col items-start self-stretch p-[16px] gap-[8px]">
              <span className="text-title-small">{t('Equipment')}</span>
              <div className="flex flex-col items-start self-stretch p-[8px] gap-[8px] rounded-[8px] border-[1px] border-[#E0E0E0] border-solid">
                {accessories.map((item, i) => {
                  return (
                    <div
                      key={i}
                      className="flex flex-col p-[8px] items-start gap-[8px] self-stretch"
                    >
                      {renderCardItem(item)}
                      {accessories.length - 1 !== i ? (
                        <Divider className="m-0 !p-0" type="horizontal" />
                      ) : null}
                    </div>
                  );
                })}
              </div>
            </div>
          </>
        ) : null}
      </>
    );
  };

  useEffect(() => {
    if (items) {
      const tempData = (() => {
        if (typeof items === 'string') {
          try {
            return parseJson(items);
          } catch (e) {
            return {};
          }
        }
        return items;
      })();
      const listModule = (() => {
        if (Array.isArray(tempData?.modules)) {
          return tempData?.modules?.map(item => {
            const moduleData = item.userData.moduleData;
            const size = item.dimensions;
            return {
              id: moduleData.id,
              name: moduleData.name,
              thumbnail_url: moduleData.thumbnail_url,
              textures: item.textures,
              moduleType: item.moduleType,
              size: `${roundTo(size.depth * 1000, 0)}x${roundTo(
                size.height * 1000,
                0
              )}x${roundTo(size.width * 1000, 0)} mm`,
              listInside: item.inside.modules,
            };
          });
        } else {
          return Object.entries(tempData.modules ?? {}).map(([, item]) => {
            const moduleData = item.userData.moduleData;
            const size = item.userData.currentSize;
            return {
              id: moduleData.id,
              name: moduleData.name,
              thumbnail_url: moduleData.thumbnail_url,
              textures: item.textures,
              moduleType: item.moduleType,
              size: `${roundTo(size.width * 1000, 0)}x${roundTo(
                size.height * 1000,
                0
              )}x${roundTo(size.depth * 1000, 0)} mm`,
              listInside: item.inside.modules,
            };
          });
        }
      })();
      const resultMapObject = mapListObjectByKey('moduleType', listModule);
      setData({ data: tempData, modules: resultMapObject });

      const countertopTexture = tempData.countertop?.texture;
      if (countertopTexture) {
        setCountertop({
          thumbnail_url: countertopTexture.url,
          name: countertopTexture.textureCode,
          // width: result.countertop?.reduce(
          //   (prev, curr) => prev + curr.length,
          //   0
          // ),
          // total: result.total?.totalOthers?.costCountertop ?? 0,
          materialType: countertopTexture.supplier.materialType,
          price: { price: countertopTexture.texturePrice },
        });
      } else {
        setCountertop(null);
      }
      const backsplashTexture = tempData.backsplash?.texture;
      if (backsplashTexture) {
        setBacksplash({
          thumbnail_url: backsplashTexture.url,
          name: backsplashTexture.textureCode,
          // width:
          //   (result.total?.totalOthers?.costBacksplash ?? 0) /
          //   (result.backsplash?.[0]?.price || 1),
          // total: result.total?.totalOthers?.costBacksplash ?? 0,

          materialType: backsplashTexture.supplier.materialType,
          price: { price: backsplashTexture.texturePrice },
        });
      } else {
        setBacksplash(null);
      }
    }
  }, [items]);

  useEffect(() => {
    if (data) {
      let accessoriesList = [];
      Object.values(data?.modules ?? {}).forEach(modules => {
        modules.forEach(item => {
          item.listInside?.forEach(insideItem => {
            if (
              [
                InsideType.ACCESSORY_COOKER,
                InsideType.ACCESSORY_GENERAL,
                InsideType.ACCESSORY_DISH_UPPER,
                InsideType.ACCESSORY_DISH_LOWER,
                InsideType.ACCESSORY_FRIDGE,
                InsideType.ACCESSORY_HOOD,
                InsideType.ACCESSORY_SINK,
                InsideType.ACCESSORY_WASHER,
                InsideType.ACCESSORY_FAUCET,
              ].includes(insideItem.type)
            ) {
              const index = accessoriesList.findIndex(
                i => i.id === insideItem.id
              );
              if (index >= 0) {
                const arr = [...accessoriesList];
                arr[index] = {
                  ...arr[index],
                  quantity: arr[index].quantity + 1,
                };
                accessoriesList = arr;
              } else {
                accessoriesList.push({
                  ...insideItem,
                  size: `${roundTo(insideItem.savedSize.x * 1000, 0)}x${roundTo(
                    insideItem.savedSize.y * 1000,
                    0
                  )}x${roundTo(insideItem.savedSize.z * 1000, 0)} mm`,
                  quantity: 1,
                });
              }
            }
          });
        });
      });
      setAccessories(accessoriesList);
    }
  }, [data]);

  return (
    <Drawer
      open={open}
      closable={false}
      classNames={{
        header: 'lg:!p-[24px] !p-[16px]',
        body: 'flex !p-0 items-start self-stretch bg-[#F5F5F5]',
        wrapper: 'lg:!w-[725px] !w-full',
        content: 'lg:!rounded-tl-[16px]',
      }}
      title={
        <div className="grid grid-cols-3 self-stretch justify-between gap-[24px] items-center grow">
          <span className="lg:text-headline-small text-title-large !font-bold col-span-2">
            {t('Product details')}
          </span>
          <div className="flex gap-[24px] items-center justify-end relative">
            {imageList?.filter(img => img)?.length > 0 && (
              <>
                <ButtonSecondaryMedium
                  title={t('View product images')}
                  onClick={() => {
                    setShowPreview(true);
                  }}
                  className="lg:flex hidden"
                />
                <div className="absolute hidden">
                  <PreviewImage
                    open={showPreview}
                    onClose={() => setShowPreview(false)}
                    imageList={imageList.filter(img => img) || []}
                  />
                </div>
              </>
            )}
            <ButtonIconOutlineMedium
              icon={<Icon.ICClose />}
              onClick={onClose}
            />
          </div>
        </div>
      }
      children={
        <div className="self-stretch flex flex-col items-start justify-start grow pb-[16px] lg:bg-transparent bg-fills-white">
          <TabComponent
            items={[
              {
                key: 'wood',
                label: (
                  <div className="flex items-center justify-start gap-[8px]">
                    <span className="w-[20px] h-[20px] flex items-center justify-center">
                      <Icon.ICStack />
                    </span>
                    <span className="text-body-large font-semibold">
                      {t('Wood product')}
                    </span>
                  </div>
                ),
              },
              {
                key: 'accessoriesAndEquipments',
                label: (
                  <div className="flex items-center justify-start gap-[8px]">
                    <span className="w-[20px] h-[20px] flex items-center justify-center">
                      <Icon.ICCountertops />
                    </span>
                    <span className="text-body-large font-semibold">
                      {t('Accessories and Equipments')}
                    </span>
                  </div>
                ),
                disabled: accessories?.length === 0,
              },
            ]}
            className={
              'lg:px-[24px] py-[12px] px-[16px] w-full [&_.ant-tabs-content-holder]:hidden'
            }
            defaultActiveKey={tab}
            onChange={value => setTab(value)}
          />
          <div className="flex p-[16px] lg:mx-[24px] lg:my-[16px] flex-col items-start self-stretch lg:rounded-[16px] bg-fills-white lg:shadow-custom lg:gap-[0] gap-[16px]">
            {tab === 'wood' && renderWoodDetail()}
            {tab === 'accessoriesAndEquipments' &&
              renderAccessoriesAndEquipmentsDetail()}
          </div>
        </div>
      }
    />
  );
};

export default DrawerDetailModule;
